// extracted by mini-css-extract-plugin
export default {"title":"ModalChangePassword_title__CPyFu","formChangePass":"ModalChangePassword_formChangePass__ZAOrB"};